import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {getGroup} from "../services/GroupService";
import {useLogout} from "./useLogout";

export function useGroup(id, {enabled = true} = {}) {
    const logout = useLogout();
    const {data, isError, error, isFetching, refetch} = useQuery({
        queryKey: ["group", id],
        queryFn: () => getGroup(id),
        enabled: enabled && id != null,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    return [data ?? null, isFetching, refetch];
}
